<script setup lang="ts">
  import type { DocumentRevision } from '@/entities/Document';
  import ApprovalTableRow from './ApprovalTableRow.vue';
  import { DefaultTable, TableHeader, HeaderTableWithButtons, SearchNoResults } from '@/shared/ui';
  import { OrderOptions } from '@/shared/lib';
  import { useTableEvents, type TableEmitter } from '@/shared/lib';
  import type { FilterOptions } from '@/entities/Document';

  withDefaults(
    defineProps<{
      revisions: DocumentRevision[];
      orderOptions?: OrderOptions[];
      isFilterActive?: boolean;
      codeColumnLabel?: string;
    }>(),
    {
      codeColumnLabel: 'Prefixo',
    }
  );

  const emit = defineEmits<{
    (e: 'update:sort', sortCamp: string, orderFlow: string): void;
    (e: 'update:filter', filters: FilterOptions): void;
    (e: 'filter-clicked'): void;
  }>();

  const { handleSortOptions, handleFilter } = useTableEvents(emit as TableEmitter);

  const handleFilterClicked = () => {
    emit('filter-clicked');
  };
</script>

<template>
  <DefaultTable class="divide-y divide-gray-02">
    <thead>
      <tr>
        <HeaderTableWithButtons
          id="header-table-with-buttons"
          colspan="6"
          text="Aprovações pendentes"
          :order-options="orderOptions"
          :is-filter-active="isFilterActive"
          @update:sort="handleSortOptions"
          @update:filter="handleFilter"
          @filter-clicked="handleFilterClicked"
        />
      </tr>
      <tr v-if="revisions.length">
        <TableHeader
          text="Data da solicitação"
          class="text-sm/5 pl-6 py-4.5"
        />
        <TableHeader
          :text="codeColumnLabel"
          class="text-sm/5"
        />
        <TableHeader
          text="Título"
          class="text-sm/5"
        />
        <TableHeader
          text="Rev."
          class="text-sm/5"
        />
        <TableHeader
          text="Elaboração"
          class="text-sm/5"
        />
        <TableHeader
          text=""
          class="text-sm/5 w-14"
        />
      </tr>
    </thead>
    <tbody class="bg-white-01 divide-y divide-gray-02">
      <tr v-if="!revisions.length">
        <td
          colspan="6"
          class="py-8"
        >
          <SearchNoResults />
        </td>
      </tr>
      <ApprovalTableRow
        v-for="revision in revisions"
        :key="revision.id"
        :revision="revision"
      />
    </tbody>
  </DefaultTable>
</template>
